<div id="<%= dom_id showcase %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Name:</strong>
    <%= showcase.name %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Key:</strong>
    <%= showcase.key %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Year:</strong>
    <%= showcase.year %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Date:</strong>
    <%= showcase.date %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Order:</strong>
    <%= showcase.order %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Location:</strong>
    <%= showcase.location_id %>
  </div>
</div>
